module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921055651_T.baa9be22.jpg";